import { render, staticRenderFns } from "./addGood.vue?vue&type=template&id=06f3671f&scoped=true"
import script from "./addGood.vue?vue&type=script&lang=js"
export * from "./addGood.vue?vue&type=script&lang=js"
import style0 from "./addGood.vue?vue&type=style&index=0&id=06f3671f&prod&lang=stylus&scoped=true"
import style1 from "./addGood.vue?vue&type=style&index=1&id=06f3671f&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f3671f",
  null
  
)

export default component.exports